import { View } from "binder"
import { ProductLineEditorViewModel } from "./productLineEditor-viewModel"
import { OpcSelectorViewModel } from "../opcSelector-viewModel";

export class ProductLineEditorView extends View<ProductLineEditorViewModel> {
    GetViewUniqueId(): string {
        return "V-12DC67A5-B337-460E-B266-8D4EF0289D28"
    }
    loadHtml(): string {
        let element = require('./productLineEditor.html').default;
        let style = require('./productLineEditor.less');
        return element;
    }
    constructor() {
        super();
    }

    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name; } private _name: string;
    public set comment(v: string) { this._comment = v; } public get comment(): string { return this._comment; } private _comment: string;
    public set opcId(v: string) { this._opcId = v; } public get opcId(): string { return this._opcId; } private _opcId: string;
    public set opcSelector(v: OpcSelectorViewModel) { this._opcSelector = v; } public get opcSelector(): OpcSelectorViewModel { return this._opcSelector; } private _opcSelector: OpcSelectorViewModel;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;

    back() {
        this.dataContext.back();
    }

    save() {
        this.dataContext.save();
    }
}
